interface Props {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, pageSize, total, onChange }: Props) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const hasPrev = page > 1;
  const hasNext = page < totalPages;

  return (
    <div className="flex items-center justify-between gap-2 pt-2">
      <button
        type="button"
        onClick={() => hasPrev && onChange(page - 1)}
        disabled={!hasPrev}
        className="flex items-center gap-1 rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 active:bg-gray-50 disabled:opacity-40"
      >
        ‹ ก่อนหน้า
      </button>
      <span className="text-sm text-gray-600">
        หน้า {page} / {totalPages}
      </span>
      <button
        type="button"
        onClick={() => hasNext && onChange(page + 1)}
        disabled={!hasNext}
        className="flex items-center gap-1 rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 active:bg-gray-50 disabled:opacity-40"
      >
        ถัดไป ›
      </button>
    </div>
  );
}
